import { getCurrentInstance, computed } from '@vue/composition-api'

export default function useTagApiService () {
    const vm = getCurrentInstance().proxy
    const store = vm.$store

    // const changeProject = computed(() => store.getters.changeProject)
    // const tags = computed(() => store.getters.tags)
    const availableTags = computed(() => store.getters['$_dynamicSearch/availableTags'])

    const fetchTags = () => {
        return [
            availableTags,
            store.dispatch('$_dynamicSearch/getUserTag')
        ]
        // const qtype = changeProject.value.event

        // if (qtype === 'group') {
        //     return [tags, store.dispatch('getTagsByGroup', { groupIdx: changeProject.value.value.groupIdx })]
        // } else if (qtype === 'project') {
        //     return [tags, store.dispatch('getTagsByProject', { projectIdx: changeProject.value.value.projectIdx })]
        // } else {
        //     return [tags, store.dispatch('getTagsAll')]
        // }
    }

    return {
        fetchTags
    }
}
